<template>
  <router-link
    :to="{name: 'player_chat_block', params: {playerId: playerId, chatBlockId: chatBlockId}}"
  >
    {{lable}} {{chatBlockId}}
  </router-link>
</template>

<script>
export default {
  name: 'PlayerChatBlockLink',

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    chatBlockId: {
      type: Number,
      required: true,
    },

    lable: {
      type: String,
      default: 'Chat block'
    }
  },
};
</script>
